export enum App {
  MASTER_APP = 'MASTER_APP',
  MANAGER_APP = 'MANAGER_APP',
  PARTICIPANT_APP = 'PARTICIPANT_APP',
  HAD = 'HAD',
  XAD = 'XAD',
}
